var data = [
  {
    path: "/ycsqing",
    component: () => import("@/components/diaodu20/apply/index.vue")
  },
  {
    path: "/ycspi",
    component: () => import("@/components/diaodu20/ycspi/index.vue")
  },
  {
    path: "/ldspi",
    component: () => import("@/components/diaodu20/ldspi/index.vue")
  },
  {
    path: "/cdpche",
    component: () => import("@/components/diaodu20/cdpche/index.vue")
  },
  {
    path: "/ccpjia",
    component: () => import("@/components/diaodu20/ccpjia/index.vue")
  },
  {
    // 申请记录
    path: "/applyRecord",
    component: () => import("@/components/diaodu20/applyRecord/index.vue")
  },
  {
    // 出车记录
    path: "/departRecord",
    component: () => import("@/components/diaodu20/departRecord/index.vue")
  },
  {
    // 状态查询
    path: "/stateSelect",
    component: () => import("@/components/diaodu20/stateSelect/index.vue")
  }
];

export default data;



// WEBPACK FOOTER //
// ./src/router/diaodu20.js